import React, { useEffect } from 'react'
import useSocket from 'tennders-common/hooks/useSocket'
import { apiGet } from 'tennders-stracture/libs/api'
import useSession from 'tennders-auth/hooks/useSession'
import { useToast } from 'tennders-common/hooks/useToast'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import { useRouter } from 'next/router'

const Transaction = React.memo(({ msg, loadRef, truckRef, openTransaction, setHotNotif }: Record<string, any>) => (
  <div onClick={() => openTransaction().then((r) => setHotNotif(null))}>
    <h4><strong>{loadRef || truckRef}</strong></h4>
    <p className="color-p">{msg}</p>
  </div>
))

const useHotNotifications = () => {
  const { user } = useSession()
  const isLoggedIn = !!user
  const { openTransaction } = useTransaction()
  const { toastHtml } = useToast()
  const { refresh, setHotNotif, hotNotif } = useSocket()
  const router = useRouter()

  const openIt = async () => {
    if (hotNotif.company) {
      router.push(`/company-detail/${hotNotif.id}`)
    } else {
      openTransaction(hotNotif?.id)
    }
  }

  useEffect(() => {
    if (isLoggedIn) {
      apiGet('/notifs/hot').then((response) => {
        if (!response || !Array.isArray(response)) {
          return
        }
        const lastNotification = response?.pop()
        if (lastNotification && (!hotNotif || hotNotif.id !== lastNotification.id)) {
          setHotNotif(lastNotification)
        }
      })
    }
    return () => setHotNotif(null)
  }, [refresh, isLoggedIn])

  useEffect(() => {
    if (hotNotif) {
      toastHtml(<Transaction setHotNotif={setHotNotif} openTransaction={openIt} {...hotNotif} />)
    }
  }, [hotNotif])
}

export default useHotNotifications
